import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireSession } from '../../../auth/require-session.js';
import { SessionError, SessionPending } from '../../../auth/SessionStates.js';

/** `/sheets/cards` (2.M): the layout of the card form, guarded as `/` is. */
export const Route = createFileRoute('/sheets/cards')({
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  staticData: { crumb: 'Card' },
  component: Outlet,
});
